import React from 'react';
import { AreaChart, Area, YAxis, ResponsiveContainer } from 'recharts';
import { STOCK_CATEGORIES, formatPrice } from '../../constants/stocks';

function StockCard({ stock, priceData, holding, onClick }) {
  if (!priceData) {
    return (
      <div className="stock-card stock-card-loading" onClick={onClick}>
        <div className="stock-card-header">
          <span className="stock-card-icon">{stock.icon}</span>
          <span className="stock-card-name">{stock.name}</span>
        </div>
        <div className="stock-card-price">Loading...</div>
      </div>
    );
  }

  const { price, changePercent, history } = priceData;
  const isPositive = changePercent >= 0;
  const category = STOCK_CATEGORIES[stock.category];

  // Prepare sparkline data
  const chartData = (history || []).map((val, i) => ({ v: val }));

  // If user holds this stock, show their P&L
  let holdingPnL = null;
  if (holding && holding.shares > 0) {
    const currentValue = holding.shares * price;
    const pnl = currentValue - holding.costBasis;
    const pnlPercent = holding.costBasis > 0 ? ((pnl / holding.costBasis) * 100) : 0;
    holdingPnL = { pnl, pnlPercent, shares: holding.shares, currentValue };
  }

  return (
    <div className={`stock-card ${isPositive ? 'stock-up' : 'stock-down'}`} onClick={onClick}>
      <div className="stock-card-header">
        <span className="stock-card-icon">{stock.icon}</span>
        <div className="stock-card-title">
          <span className="stock-card-name">{stock.name}</span>
          <span className="stock-card-category" style={{ color: category?.color }}>
            {category?.label}
          </span>
        </div>
      </div>

      <div className="stock-card-chart">
        {chartData.length > 2 && (
          <ResponsiveContainer width="100%" height={50}>
            <AreaChart data={chartData} margin={{ top: 2, right: 0, left: 0, bottom: 2 }}>
              <defs>
                <linearGradient id={`sparkGrad-${stock.id}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={isPositive ? '#4ADE80' : '#EF4444'} stopOpacity={0.4} />
                  <stop offset="100%" stopColor={isPositive ? '#4ADE80' : '#EF4444'} stopOpacity={0} />
                </linearGradient>
              </defs>
              <YAxis domain={['dataMin', 'dataMax']} hide />
              <Area
                type="monotone"
                dataKey="v"
                stroke={isPositive ? '#4ADE80' : '#EF4444'}
                strokeWidth={1.5}
                fill={`url(#sparkGrad-${stock.id})`}
                dot={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>

      <div className="stock-card-footer">
        <div className="stock-card-price">
          <span className="stock-price-value">{formatPrice(price)}</span>
        </div>
        <div className={`stock-card-change ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? '+' : ''}{changePercent.toFixed(2)}%
        </div>
      </div>

      {holdingPnL && (
        <div className="stock-card-holding">
          <span className="stock-holding-shares">{holdingPnL.shares.toFixed(4)} shares</span>
          <span className={`stock-holding-pnl ${holdingPnL.pnl >= 0 ? 'positive' : 'negative'}`}>
            {holdingPnL.pnl >= 0 ? '+' : ''}{holdingPnL.pnl.toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
}

export default StockCard;
